import { inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource } from "../../../../shared/async/PromiseCompletionSource";
import { Viewable } from "../../../../scene/viewable/Viewable";
import { SmallWinCoinsPopupView } from "./view/SmallWinCoinsPopupView";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";
import { ISmallWinCoinsController } from "./controllers/ISmallWinCoinsController";
import { DeadRollSmallCoinsAction } from "../../game/flow/impl/diceActions/DeadRollSmallCoinsAction";
import { SoundsResourcePackageWrapper } from "../../common/resources/SoundsResourcePackageWrapper";
import { TopPanel } from "../../game/components/toppanel/TopPanel";

@injectable()
export class SmallWinCoinsPopupScene extends Viewable<void> {
    public constructor(
        commonResources: CommonResourcesPackage,
        soundResources: SoundsResourcePackageWrapper,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("ISmallWinCoinsController") smallWinCoinsController: ISmallWinCoinsController,
        action: DeadRollSmallCoinsAction,
        topPanel: TopPanel
    ) {
        super();
        topPanel.interactiveChildren = false;
        const pcs = new PromiseCompletionSource<void>();
        this.view = new SmallWinCoinsPopupView(
            pcs,
            commonResources,
            soundResources,
            canvasScaler,
            smallWinCoinsController,
            action,
            topPanel
        );
        pcs.result.then(() => {
            topPanel.interactiveChildren = true;
            this.operationControls.complete();
        }, (reason: any) => {
            topPanel.interactiveChildren = true;
            this.operationControls.error(reason);
        });
    }
}
